export default __webpack_public_path__ + "static/media/cont_w_bg.b01c15d8.png";